/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomAttributeFloorsDistributionNumeric
 */
export interface CustomAttributeFloorsDistributionNumeric {
    /**
     * 
     * @type {number}
     * @memberof CustomAttributeFloorsDistributionNumeric
     */
    valueMin?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomAttributeFloorsDistributionNumeric
     */
    valueMax?: number;
}

export function CustomAttributeFloorsDistributionNumericFromJSON(json: any): CustomAttributeFloorsDistributionNumeric {
    return CustomAttributeFloorsDistributionNumericFromJSONTyped(json, false);
}

export function CustomAttributeFloorsDistributionNumericFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomAttributeFloorsDistributionNumeric {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'valueMin': !exists(json, 'valueMin') ? undefined : json['valueMin'],
        'valueMax': !exists(json, 'valueMax') ? undefined : json['valueMax'],
    };
}

export function CustomAttributeFloorsDistributionNumericToJSON(value?: CustomAttributeFloorsDistributionNumeric | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'valueMin': value.valueMin,
        'valueMax': value.valueMax,
    };
}


